module.exports = __webpack_public_path__ + "assets/ac456127d6c91207b902a6a9df9c0b20.mp3";